module.exports = __webpack_public_path__ + "static/media/dropdown.9cc12d4f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dropdown.svg
// module id = 1081
// module chunks = 0